<div class="cm-config-dropdowns-menu">
    @for (desc of $interfaceDescriptors(); track desc.props.id) {
        @if ($isConfigInput()(desc)) {
            <mat-form-field>
                <mat-label>{{ desc.props.name }}</mat-label>
                <mat-select [value]="desc.props.value?.id">
                    @for (variant of desc.props.variants; track variant.id) {
                        <mat-option [value]="variant.id" (click)="configMenuService.emitConfigSelected({config: desc, variant})">
                            {{ variant.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if ($isMaterialInput()(desc)) {
            {{ desc.props.name }}
            <cm-select-material-button [materialInfo]="desc"></cm-select-material-button>
        }
        @if ($isBooleanInput()(desc)) {
            <cm-input-container>
                <ng-container cm-inline-label> {{ desc.props.name }} </ng-container>
                <cm-toggle [toggle]="desc.props.value ?? false" (toggleChange)="configMenuService.emitValueChanged({config: desc, value: $event})"> </cm-toggle>
            </cm-input-container>
        }
        @if ($isNumberInput()(desc)) {
            <cm-input-container>
                <ng-container cm-inline-label> {{ desc.props.name }} </ng-container>
                <ng-container cm-input>
                    <cm-numeric-input
                        [value]="desc.props.value ?? 0"
                        [decimalPlaces]="2"
                        [emptyValue]="0"
                        (valueChange)="configMenuService.emitValueChanged({config: desc, value: $event ?? undefined})"
                    >
                    </cm-numeric-input>
                </ng-container>
            </cm-input-container>
        }
        @if ($isStringInput()(desc)) {
            <cm-input-container>
                <ng-container cm-inline-label> {{ desc.props.name }}</ng-container>
                <ng-container cm-input>
                    <cm-string-input [value]="desc.props.value ?? ''" (valueChange)="configMenuService.emitValueChanged({config: desc, value: $event})">
                    </cm-string-input>
                </ng-container>
            </cm-input-container>
        }
    }
</div>
